export const mockPreFixture = {
  _id: '685c06e843c57eea756709ce',
  name: 'Ecopetrol',
  classification: 'charterer',
  type: 'pre-fixture',
  sourceData: ['Q88'],
  standardCertificates: ['USCG Certificate of Compliance (USCGCOC)'],
  otherCertificates: ['q88'],
  remarks: '<p>to load minimum :</p><p><br></p><p><br></p><p>1,000,000 .</p>',
  createdBy: 'system',
  createdAt: '2025-06-25T14:25:31.430Z',
  history: [],
  updatedAt: '2025-07-15T09:40:10.322Z',
  updatedBy: 'accountmanager@test.dk',
  isActive: true,
}
